import * as React from "react";
import {
  Error500 as BaseError500,
  Error404 as BaseError404,
} from "./ServerResponse";
import { useAppSettings } from "@skv/state";

export const Error500: React.FC = () => {
  const { seekVolunteerUrl } = useAppSettings();

  return (
    <BaseError500
      contactUsTo={`${seekVolunteerUrl}/help-and-support/contact-us`}
    />
  );
};

export const Error404: React.FC = () => {
  const { seekVolunteerUrl } = useAppSettings();

  return (
    <BaseError404
      contactUsTo={`${seekVolunteerUrl}/help-and-support/contact-us`}
    />
  );
};
